import { S3Client } from "@aws-sdk/client-s3";
import { RekognitionClient } from "@aws-sdk/client-rekognition";
import { getValidSession } from "./awsSessionManager";

const REGION = process.env.REACT_APP_AWS_REGION;

export function createCredentialProvider() {
  return async () => {
    const session = await getValidSession(sessionStorage.getItem('sessionToken'));

    console.log("Using AWS Credentials with Access Key ID:", session);

    return {
      accessKeyId: session.accessKeyId,
      secretAccessKey: session.secretAccessKey,
      sessionToken: session.sessionToken,
    };
  };
}

export function createS3Client() {
  return new S3Client({
    region: REGION,
    credentials: createCredentialProvider(),
    requestChecksumCalculation: "WHEN_REQUIRED",
  });
}

export function createRekognitionClient() {
  console.log("Creating Rekognition Client");
  return new RekognitionClient({
    region: REGION,
    credentials: createCredentialProvider(),
  });
}
